module.exports = __webpack_public_path__ + "02e7c9af7f203f881b5e00cf438982c4.png";